
import { isNullOrUndefined } from './validation';
import { environment } from 'src/environments/environment';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Component, HostListener } from '@angular/core'
import { Title } from '@angular/platform-browser';
import { BnNgIdleService } from 'bn-ng-idle';
import { ClientDataService } from './services/client-data.service';
import { EncrdecrService } from './Auth/encrdecr.service';
import { LoginService } from './services/login.service';
import { CustomLoaderService } from './services/custom-loader.service';
import { TokenExpireService } from './services/token-expire.service';
import { MainHeaderMenuService } from './services/main-header-menu.service';
import { Observable, Subscription } from 'rxjs';
import { PlatformLocation } from '@angular/common';
import { LocalStoargeService } from './services/local-stoarge.service';
import { trigger, transition, style, animate } from '@angular/animations';

declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})

export class AppComponent {

  showScrollBtn = false;
  scrollProgress = 0;
  readonly ringCircumference = 2 * Math.PI * 20;
  // Companyname: string = 'AU';
  CompanyLogo: any;
  href: any;
  IsLoaded = false;
  Companyname: string = environment.CompayName;
  CommonBaseHref: string = environment.CommonBaseHref;
  PrimaryColor: string = '';
  SecondaryColor: string = '';
  ThirdColor: string = '';
  BodyColor: string = '';
  BodyBgColor: string = '';
  BodyFooterBgColor: string = '';
  Table_Header_Bg = '';
  Table_Head_Text = '';
  fontFamily = '';
  favIcon: HTMLLinkElement = document.querySelector('#Fevicon');
  //MainLogo: HTMLImageElement = document.querySelector('#MainLogo');
  logo: string;
  loader: string;
  loaderWidth: string;
  loaderHeight: string;
  SessionTime: number = 86400;// Changed by Rohan from 1200 sec to 86400 sec (24 hr) 17/06/2025;
  IsMobile: boolean = false;
  IsLoggedIn: boolean = false;
  isLoggedIn$: Observable<boolean>;
  LoaderText: string = "";
  private routerSubscription: Subscription;
  constructor(private Idle: BnNgIdleService,
    private titleService: Title,
    private ClientDataService: ClientDataService,
    private EncrdecrService: EncrdecrService,
    private LoginService: LoginService,
    private router: Router,
    public Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private MainHeaderMenuService: MainHeaderMenuService,
    location: PlatformLocation,
    private localStorageService:LocalStoargeService
  ) { // initiate it in your component constructor
    //sessionStorage.removeItem('6+J3RebINEPBJVbAJw');

    // window.onbeforeunload = function (event) {
    //   alert('refresh is clicked')
    // };

    // window.addEventListener('beforeunload', function () {
    //   alert('refresh is clicked')


    // })
    location.onPopState(() => {
      // this.CloseWindow();
      if (sessionStorage.getItem("HLIHOLK332") != undefined && sessionStorage.getItem("HLIHOLK332") != null) {
        let value = sessionStorage.getItem("HLIHOLK332")
        if (value == "FromReport") {
          //$('#ExpandCollapse').trigger('click');
          // $('.MainBg').addClass('collapsed_Menu');
          // $('.MainBg.collapsed_Menu').css('padding-left', '68px');
          $('.MainBg').removeClass("collapsed_Menu");
        }
        // sessionStorage.removeItem("HLIHOLK332")
      }
      // $('.modal-backdrop').remove();
      $('.modal').modal('hide');
      // $('#FilterModal').modal('toggle')
      $('.datepicker').removeClass("datepicker-dropdown dropdown-menu")
      $('.select2-container').removeClass("select2-container--default select2-container--open")

    });
    // start commented by Rohan 17062025
    // this.Idle.startWatching(this.SessionTime).subscribe((res) => {
    //   if (res) {
    //     this.MainHeaderMenuService.hide();
    //     if (sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF') != null && sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF') != undefined && sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF') != "") {
    //       const isLoggtedIn = this.EncrdecrService.getDecr(sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF'));
    //       if (isLoggtedIn == "1") {
    //         this.IsLoggedIn = true;
    //       }
    //       else {
    //         this.IsLoggedIn = false;
    //       }
    //     } else {
    //       this.IsLoggedIn = false;
    //     }
    //     if (res == true) {

    //       switch (this.Companyname) {
    //         case 'JMF':
    //           this.ClientDataService.SetWelcomeText('InCred Markets');
    //           this.titleService.setTitle('InCred Markets');
    //           sessionStorage.setItem('logo', '../../assets/images/iifl-securities-logo.svg');
    //           sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("18"));
    //           sessionStorage.setItem('Abodhj#@jdkd/%^ysudsh&#&shdj@#$', "18");
    //           sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
    //           break;
    //       }
    //       let path = window.location.pathname.toLowerCase();
    //       if (path != '/login-incred' && !path.includes("login") && path != '/index' && path != '/ipo' && path != '/ipo/' && path != '/ipo/index' && path != '/') {
    //         $('.modal').modal('hide');
    //         debugger
    //         this.SessionExpired();
    //         const LoginSource = sessionStorage.getItem('6+J3RebINEPBJVbAJw');
    //         if (LoginSource == null || LoginSource == undefined || LoginSource == '' && this.Companyname != "AU") {
    //           $('#SessionModal').modal({
    //             backdrop: 'static',
    //             keyboard: false
    //           });
    //         }
    //       }
    //       history.pushState(null, null, window.location.href);
    //       history.back();
    //       window.onpopstate = () => history.forward();
    //       $('select').select2('close');
    //     }
    //   }
    // })
    //this.getCompanyDetails();
    // end Rohan commented
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth)
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrolled = window.scrollY;
    const max = document.body.scrollHeight - window.innerHeight;
    this.scrollProgress = max > 0 ? Math.min(scrolled / max, 1) : 0;
    this.showScrollBtn = scrolled >= 200;
  }

  get ringDashoffset(): number {
    return this.ringCircumference * (1 - this.scrollProgress);
  }

  scrollToTop() {
    const duration = 800;
    const start = window.scrollY;
    const startTime = performance.now();
    const animateScroll = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const ease = progress < 0.5 
        ? 2 * progress * progress 
        : -1 + (4 - 2 * progress) * progress;
      window.scrollTo(0, start * (1 - ease));
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };
    requestAnimationFrame(animateScroll);
  }


  ngOnInit() {
    if (!(!!sessionStorage.getItem('dsfagzvxctwre'))) sessionStorage.setItem('dsfagzvxctwre', '1')
    console.log("Last Session Value before refresh: ", sessionStorage.getItem("HLIHOLK332"))
    // this.FnIsCollapseSideMenu('FromReport');
    if (sessionStorage.getItem("HLIHOLK332") != undefined && sessionStorage.getItem("HLIHOLK332") != null) {
      let value = sessionStorage.getItem("HLIHOLK332")
      if (value == "FromReport" || value == "") {
        $('#sidebar .Sidemenu').addClass('collapsed')
      }
    }
    window.addEventListener('refresh', function (event) {
      console.log("This is inside refresh function and value is: ", sessionStorage.getItem("HLIHOLK332"))
      event.preventDefault();
    });
    const previousPageUrl = document.referrer;
    console.log(`Previously visited page URL: ${previousPageUrl}`);
    $('input[type="text"]').blur(function () {
      setTimeout(function () {
        if (!$(document.activeElement).is('input[type="text"]')) {
          $(window).scrollTop(0, 0);
        }
      }, 0);
    });
    $('.datepicker.datepicker-dropdown').blur(function () {
      setTimeout(function () {
        if (!$(document.activeElement).is('.datepicker.datepicker-dropdown')) {
          $(window).scrollTop(0, 0);
        }
      }, 0);
    });
    // window.onbeforeunload = function (event) {
    //   // event.returnValue = 'Your custom message here';
    //   // window.close()
    //   event.preventDefault();
    //   // return 'Your custom message here';

    // };

    //   window.onbeforeunload = function(event) {
    //     // Show a confirmation dialog when the refresh button is clicked
    //     return "Are you sure you want to refresh?";
    // };

    this.isLoggedIn$ = this.MainHeaderMenuService.isShowHeader;
    this.SetViewPort(window.innerWidth);
    const isNotLoginPage = !window.location.href.includes('login-emp');
    if (isNotLoginPage && this.Companyname == 'JMF') {
      $('body').css('min-height', window.innerHeight - 66)
      //$('.MainOuter').css('min-height', window.innerHeight - 72);
    }

    setInterval(() => {
      if (sessionStorage.getItem("sdljncsioejt349rjf0-rifkec") != undefined &&
        sessionStorage.getItem("sdljncsioejt349rjf0-rifkec") != null) {
        this.LoaderText = sessionStorage.getItem("sdljncsioejt349rjf0-rifkec");
      }
    }, 300)

    //
    $('.modal').modal('hide');
    this.Dynamic_Class();
    // this.getCompanyDetails();
    switch (this.Companyname) {
      case 'JMF':
        this.PrimaryColor = '#f47920'; //#032B5B
        this.SecondaryColor = '#282828';
        this.ThirdColor = '#282828';
        if(this.IsMobile){
          this.BodyColor = '#0F1724';
        }else{
          this.BodyColor = '#0F1724';
        }
        this.BodyBgColor = '#F7F8FA' // f5f6f7
        this.BodyFooterBgColor = '#282828';
        this.Table_Header_Bg = '#f3f3f3';
        this.Table_Head_Text = '#252525';
        this.fontFamily = 'Figtree';
        this.ClientDataService.SetWelcomeText('InCred Markets');
        this.titleService.setTitle('InCred Markets');
        // this.favIcon.href = './assets/images/IIFLfavicon.png';
        this.favIcon.href = './assets/images/favicon_INC.ico';
        this.loader = '../../assets/images/IIFL-Loader.gif';
        this.loaderWidth = '100px';
        this.loaderHeight = '100px';
        sessionStorage.setItem('logo', '../../assets/images/InCred_capital_NewLogo.svg');
        sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("18"));
        sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        break;
    }
    this.ClientDataService.SetCompanyName(this.Companyname);
    document.documentElement.style.setProperty('--primary-color', this.PrimaryColor);
    document.documentElement.style.setProperty('--secondary-color', this.SecondaryColor);
    document.documentElement.style.setProperty('--third-color', this.ThirdColor);
    document.documentElement.style.setProperty('--body-color', this.BodyColor);
    document.documentElement.style.setProperty('--body-bg-color', this.BodyBgColor);
    document.documentElement.style.setProperty('--body-footer-bg-color', this.BodyFooterBgColor);
    document.documentElement.style.setProperty('--table-header-bg-color', this.Table_Header_Bg);
    document.documentElement.style.setProperty('--table-header-text-color', this.Table_Head_Text);
    document.documentElement.style.setProperty('--font-family-regular', `${this.fontFamily}Regular`);
    document.documentElement.style.setProperty('--font-family-semibold', `${this.fontFamily}SemiBold`);
    document.documentElement.style.setProperty('--font-family-bold', `${this.fontFamily}Bold`);

  }
  Dynamic_Class() {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url.includes('/transaction-new-latest')) {
          document.body.classList.add('New_IIFL_Transact'); // Add 'New_IIFL_Transact' class when navigating to the specific route
        }
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        if (!event.url.includes('/transaction-new-latest')) {
          document.body.classList.remove('New_IIFL_Transact'); // Remove 'New_IIFL_Transact' class when leaving the page
        }
      }
    });
  }
  // Dynamic_For_Clients_filter(){
  //   this.routerSubscription = this.router.events.subscribe(event => {
  //     if (event instanceof NavigationStart) {
  //       if (event.url.includes('/transaction-new-latest')) {
  //         document.body.classList.add('New_IIFL_Transact'); // Add 'New_IIFL_Transact' class when navigating to the specific route
  //       }
  //     } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
  //       if (!event.url.includes('/transaction-new-latest')) {
  //         document.body.classList.remove('New_IIFL_Transact'); // Remove 'New_IIFL_Transact' class when leaving the page
  //       }
  //     }
  //   });
  // }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }
  getCompanyDetails() {
    //////
    // if(session)
    //  sessionStorage.removeItem("E#$%#XCha7%*=");
    //  sessionStorage.removeItem("Vbhs@#%LMKIo=");
    //  sessionStorage.removeItem("DufjGDH3843JE");
    //  sessionStorage.removeItem("PfdkSJDNWks2323Ms");
    //  sessionStorage.removeItem("Arh34SDBJSSiF");

    this.ClientDataService.getCompanyDetails(environment.CompanyId).subscribe((data: any) => {
      //
      //
      if (data != null && data.ArrayOfResponse.length != 0) {

        //let dtsa = this.EncrdecrService.getDecr(data.ArrayOfResponse[0].Dummy2);
        //this.Loader.hide();
        let rk = data.ArrayOfResponse[0];
        //console.log('Corp_IFA = ' + this.EncrdecrService.getDecr(rk.Dummy1));
        //this.Companyname = rk.CompanyName;
        // if(this.Companyname == 'AU')
        // {
        // sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$',this.EncrdecrService.setEncr("4"));
        // sessionStorage.setItem('Mnuoisns6wqgswj2$#',"1");
        // }
        // else{
        // sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$',this.EncrdecrService.setEncr("0"));
        // sessionStorage.setItem('Mnuoisns6wqgswj2$#',"0");
        // }

        var str = this.EncrdecrService.getDecr(rk.Dummy1);
        sessionStorage.setItem('E#$%#XCha7%*=', this.EncrdecrService.getDecr(rk.Dummy2));
        sessionStorage.setItem('Vbhs@#%LMKIo=', this.EncrdecrService.getDecr(rk.Dummy1));
        sessionStorage.setItem('DufjGDH3843JE', this.EncrdecrService.getDecr(rk.Dummy4));
        sessionStorage.setItem('PfdkSJDNWks2323Ms', this.EncrdecrService.getDecr(rk.Dummy3));
        sessionStorage.setItem('Arh34SDBJSSiF', this.EncrdecrService.getDecr(rk.Dummy5));
        sessionStorage.setItem('Fhd63asja$%Wsdjs9304#@dfvdjfjd', this.EncrdecrService.getDecr(rk.Dummy6));
        sessionStorage.setItem('%^&s8g9b!@fla%g', this.EncrdecrService.getDecr(rk.Dummy7));
        sessionStorage.setItem('JikLG6K4LOdfv', this.EncrdecrService.getDecr(rk.Dummy11));
        if (!isNullOrUndefined(rk.Dummy12)) {
          sessionStorage.setItem('Hjgir56hutHLB', this.EncrdecrService.getDecr(rk.Dummy12));
        }

        try {
          if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy8))) {
            sessionStorage.setItem('trtygy$gtdr&dft=', this.EncrdecrService.getDecr(rk.Dummy8));
          } else {
            sessionStorage.setItem('trtygy$gtdr&dft=', 'false');
          }
        }
        catch (e) {
          sessionStorage.setItem('trtygy$gtdr&dft=', 'false');
        }
        try {
          if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy9))) {
            sessionStorage.setItem('hgjhfjg&jbfj%dfgs=', this.EncrdecrService.getDecr(rk.Dummy9));
          } else {
            sessionStorage.setItem('hgjhfjg&jbfj%dfgs=', 'false');
          }
        }
        catch (e) {
          sessionStorage.setItem('hgjhfjg&jbfj%dfgs=', 'false');
        }
        try {
          if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy10))) {
            sessionStorage.setItem('dsa&hdhbc%ube=', this.EncrdecrService.getDecr(rk.Dummy10));
          } else {
            sessionStorage.setItem('dsa&hdhbc%ube=', 'false');
          }
          sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', this.EncrdecrService.getDecr(rk.EnableRiskProfile));
        }
        catch (e) {
          sessionStorage.setItem('dsa&hdhbc%ube=', 'false');
        }

        // if (this.Companyname == 'Mahindra') {


        // }

        // if(rk.Dummy1 !="" && rk.Dummy1!=null && rk.Dummy1!=undefined){
        //   sessionStorage.setItem('Vbhs@#%LMKIo=',"N");
        //   console.log('Corp_IFA_i = ' + sessionStorage.getItem('Vbhs@#%LMKIo='));
        // }
        //this.EncrdecrService.getDecr(rk.CompanyName);
      }
    });
  }
  SessionExpired() {
    debugger
    let LoginToken = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    this.LoginService.Logout(LoginToken).subscribe(
      (res: any) => {

        const sessionvalue = sessionStorage.getItem('nvjsd212djskd$#21ksdj');

        if (sessionvalue != undefined && sessionvalue != null && sessionvalue != '') {
          // if (sessionvalue == 'C') {

          //   this.Logout.LogoutUser();
          // }
          // else if (sessionvalue == 'E') {

          //   this.router.navigateByUrl('/employee-login');
          // }
          this.Logout.LogoutUser();
        }
        else {
          sessionStorage.clear();
          // localStorage.clear();
          let w = window.innerWidth

          if (w <= 767) {
            this.router.navigateByUrl("/mobilesession")
          } else {
            this.localStorageService.ClearLocalStorageWithoutCleverTapKeys();// Added by Tishya
          this.router.navigateByUrl('/login-cp');
          }
        }

        switch (this.Companyname) {
          case 'JMF':
            sessionStorage.setItem('logo', '../../assets/images/InCred_capital_NewLogo.svg');
            sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("18"));
            sessionStorage.setItem('Abodhj#@jdkd/%^ysudsh&#&shdj@#$', "18");
            sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
            break;
        }
      }
    );
  }
  RedirectTODashBoard() {
    var G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))); //Session_UserType
    if (G_UserType == 3) {
      this.router.navigateByUrl('/client-dashboard');
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }

  FnIsCollapseSideMenu(e) {
    console.log("Collasped side menu function triggered!")
    // debugger
    if (e) {
      $('.MainBg').addClass('collapsed_Menu');
      sessionStorage.setItem("HLIHOLK332", "FromReport");
      // $('.MainBg').removeClass('collapsed_Menu');

    }
    else {
      $('.MainBg').removeClass('collapsed_Menu');
      // sessionStorage.setItem("HLIHOLK332","!FromReport");
      sessionStorage.setItem("HLIHOLK332", "FromHamBurger")

    }
  }
  GoToClientProfile() {
    this.router.navigateByUrl('/Client-Profile-Preview/Preview');
  }
  ngOnDestroy() {
    // Unsubscribe from the router events to avoid memory leaks
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
  get isComprehensivePage(): boolean {
    return this.router.url === "/comprehensive";
  }
}
// ===== Scroll to Top ====
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() >= 200) {
  //     $('#return-to-top').fadeIn(200);  
  //   } else {
  //     $('#return-to-top').fadeOut(200);
  //   }
  // });
$(document).ready(function () {
  // $('#return-to-top').click(function () { 
  //   $('body,html').animate({
  //     scrollTop: 0              
  //   }, 500);
  // });

  $(".numonly").on("input", function () {
    var regexp = /[^\d\.\-]/g;
    if ($(this).val().match(regexp)) {
      $(this).val($(this).val().replace(regexp, ''));
    }
  });

  $(".alphaonly").on("input", function () {
    var regexp = /[^a-zA-Z ]/g;
    if ($(this).val().match(regexp)) {
      $(this).val($(this).val().replace(regexp, ''));
    }
  });

});


